<template>
    <tbody v-if="server">
        <tr>
            <td colspan="2"><h2>Server Information</h2></td>
        </tr>

        <tr>
            <td width="25%">Server Info:</td>

            <td>{{ server.software }}</td>
        </tr>

        <tr>
            <td width="25%">Server IP Address:</td>

            <td>{{ server.ip_address }}</td>
        </tr>

        <tr>
            <td width="25%">Server Protocol:</td>

            <td>{{ server.protocol }}</td>
        </tr>

        <tr>
            <td width="25%">Server Administrator:</td>

            <td>{{ server.administrator }}</td>
        </tr>

        <tr>
            <td width="25%">Server Web Port:</td>

            <td>{{ server.webport }}</td>
        </tr>
        <tr>
            <td width="25%">CGI Version:</td>

            <td>{{ server.cgi_version }}</td>
        </tr>


        <tr>
            <td>PHP Version:</td>

            <td><span class="yes">{{ server.php_version }}</span></td>
        </tr>
        <tr>
            <td>PHP Max Upload Size:</td>

            <td>{{ server.php_max_upload_size }}</td>
        </tr>
        <tr>
            <td>PHP Max Execution Time:</td>

            <td>{{ server.php_max_execution_time }}</td>
        </tr>
        <tr>
            <td>PHP Max Input Vars:</td>

            <td>{{ server.php_max_input_vars }}</td>
        </tr>
        <tr>
            <td>cURL Version:</td>

            <td>{{ server.php_curl_version }}</td>
        </tr>
        <tr>
            <td>PHP Soap Installed:</td>

            <td>{{ server.php_soap }}</td>
        </tr>
        <tr>
            <td>MySQL Version:</td>

            <td>
                <span class="yes">{{ server.mysql_version }}</span>
            </td>
        </tr>
        <tr>
            <td>Default Timezone is UTC:</td>

            <td>
                <span class="yes" v-if="server.php_default_timezone === 'UTC'">
                    <span class="dashicons dashicons-yes"></span>Yes
                </span>
                <span class="no" v-else>
                    <span class="dashicons dashicons-no"></span>No
                </span>
            </td>
        </tr>
        <tr>
            <td>PHP Extensions:</td>

            <td>{{ server.php_extensions }}</td>
        </tr>


        <tr>
            <td data-export-label="fsockopen/cURL">fsockopen/cURL:</td>

            <td>
                <span class="yes" v-if="server.php_fsockopen === 'Yes'">
                    <span class="dashicons dashicons-yes"></span>Yes
                </span>
                <span class="no" v-else>
                    <span class="dashicons dashicons-no"></span>No
                </span>
            </td>
        </tr>
        <tr>
            <td data-export-label="DOMDocument">DOMDocument:</td>

            <td>
                <span class="yes" v-if="server.php_dom_document === 'Yes'">
                    <span class="dashicons dashicons-yes"></span>Yes
                </span>
                <span class="no" v-else>
                    <span class="dashicons dashicons-no"></span>No
                </span>
            </td>
        </tr>
        <tr>
            <td data-export-label="GZip">GZip:</td>

            <td>
                <span class="yes" v-if="server.gzip === 'Yes'">
                    <span class="dashicons dashicons-yes"></span>Yes
                </span>
                <span class="no" v-else>
                    <span class="dashicons dashicons-no"></span>No
                </span>
            </td>
        </tr>
        <tr>
            <td data-export-label="Multibyte String">Multibyte String:</td>

            <td>
                <span class="yes" v-if="server.mbstring === 'Yes'">
                    <span class="dashicons dashicons-yes"></span>Yes
                </span>
                <span class="no" v-else>
                    <span class="dashicons dashicons-no"></span>No
                </span>
            </td>
        </tr>
        <tr>
            <td data-export-label="Remote Get Status">Is SSL:</td>

            <td>
                <span class="yes" v-if="server.is_ssl">
                    <span class="dashicons dashicons-yes"></span> Yes
                </span>
                <template v-else>
                    <span class="no">
                        <span class="dashicons dashicons-no"></span> No
                    </span><br>
                    <small>
                        An HTTPS connection is a more secure way of browsing the web. Many services now have HTTPS as a requirement. HTTPS allows you to take advantage of new features that can increase site speed, improve search rankings, and gain the trust of your visitors by helping to protect their online privacy.
                        <a href="https://wordpress.org/support/article/why-should-i-use-https/" target="_blank" rel="noopener noreferrer">Learn more about why you should use HTTPS <span class="screen-reader-text">(opens in a new tab)</span><span aria-hidden="true" class="dashicons dashicons-external"></span></a>
                    </small>
                </template>

            </td>
        </tr>
    </tbody>
</template>
<script>
export default {
    name: 'WordPressInfo',

    props: ['server']
};
</script>
